import { render, staticRenderFns } from "./resourceGroupDialog.vue?vue&type=template&id=47c6683a&"
import script from "./resourceGroupDialog.vue?vue&type=script&lang=js&"
export * from "./resourceGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports